import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  locations: [],
  svg: ''
}

const getters = {
  getMapLocations: state => state.locations,
  getMapSvg: state => state.svg
}

const actions = {
  async fetchMapLocations ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.mapLocations.get())
      commit(types.SET_MAP_LOCATIONS, data)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Error in loading locations!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchMapSvg ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(`${location.origin}/static/floor-plan/map-dubai.svg`)
      commit(types.SET_MAP_SVG, data)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Error in loading map!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addMapLocation ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.mapLocations.add(), payload)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Error in adding location!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteMapLocation ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.mapLocations.delete(id))
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Error in delete location!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_MAP_SVG] (state, text) {
    state.svg = text
  },
  [types.SET_MAP_LOCATIONS] (state, { mapLocations }) {
    state.locations = [...mapLocations]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/map-locations.js